// extracted by mini-css-extract-plugin
module.exports = {"trademarks":"trademarks_trademarks__1qtCq"};